<app-header *ngIf="(!isMngHeaderVisible && !isNavBarVisible && isHeader)" [isLoggedIn]="isLoggedIn"></app-header>

<app-header-mng *ngIf="isNavBarVisible" [isMngLoggedIn]="isMngLoggedIn"></app-header-mng>

<app-nav-side-bar *ngIf="isNavBarVisible" class="sideBarMngWrapper"></app-nav-side-bar>

<app-menu-bar *ngIf="!isMngHeaderVisible && isHeader" class="storeMain"></app-menu-bar>

<app-store-info-bar *ngIf="showStoreInfoBar"></app-store-info-bar>

<!-- <div id="main" class="main isSidebar" role="main" *ngIf="!isLoggedIn" 
[ngClass]="{'isSidebar' : isLoggedIn}"> -->
<!-- <div class="container-fluid"> -->
<router-outlet> </router-outlet>
<!-- </div> -->
<!-- </div> -->
<div id="main" class="main" role="main" [ngClass]="{'isSidebar manageMain' : isNavBarVisible, 'storeMain' : !isNavBarVisible}">
  <!-- <div class="container-fluid"> -->
  <router-outlet> </router-outlet>
  <!-- </div> -->
</div>
<!-- <app-footer></app-footer> -->
<app-alert-main></app-alert-main>